import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import { solid, regular, brands } from "@fortawesome/fontawesome-svg-core/import.macro";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Toast } from "primereact/toast";
import {
  addCourseBookmark as addCourseBookmarkService,
  removeCourseBookmark as removeCourseBookmarkService,
  addCollarBookmark as addCollarBookmarkService,
  removeCollarBookmark as removeCollarBookmarkService,
} from "../../services/courseDetailService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
import { Config } from "../../constants/Config";
import tagManagerEvents from "../../utils/GoogleTagManager";
import { NavigateToLanding, getDataFromCookies } from "../../utils/CommonFunction";

export interface CoursesCardProps {
  data: any;
  token?: string;
  utm_source?: string;
  courseId?: string | number;
  courseName?: string;
  refresh?: () => void;
}

export default function CoursesCard(props: CoursesCardProps) {
  const [data, setData] = useState(props.data);
  const MySwal = withReactContent(Swal);
  const toast = useRef<any>(null);
  const navigate = useNavigate();
  const { cookieMsisdn, cookieSubscribeId } = getDataFromCookies();

  useEffect(() => {
    // console.log("data from parents", data);
  }, [data, props.token]);

  const _copy = (dataUrl: string) => {
    navigator.clipboard
      .writeText(dataUrl)
      .then((resp) => {
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Copied",
            detail: "Url copied to clipboard",
            life: 3000,
          });
        }
        console.log(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const _share = () => {
    tagManagerEvents("Share", props.utm_source);
    if (navigator.share) {
      if (data.chapterNumber) {
        navigator.share({
          title: data.title,
          text: data.title,
          url:
            window.location.protocol +
            "//" +
            window.location.host +
            "/course_detail?courseId=" +
            props.courseId +
            "&chapterId=" +
            data.id,
        });
      } else {
        navigator.share({
          title: data.title,
          text: data.description,
          url:
            window.location.protocol +
            "//" +
            window.location.host +
            "/course_detail?courseId=" +
            data.course.id +
            "&videoId=" +
            data.id,
        });
      }
    } else {
      MySwal.fire({
        title: <p>Share on Social Media</p>,
        confirmButtonColor: "#c10009",
        confirmButtonText: "close",
        html: (
          <div>
            <a
              target="_blank"
              rel="noreferrer"
              className="text-success"
              onClick={() => MySwal.close()}
              href={
                data.chapterNumber
                  ? "https://api.whatsapp.com/send?text=Title: " +
                    data.title +
                    "%0aUrl: " +
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/course_detail?courseId=" +
                    props.courseId +
                    "&chapterId=" +
                    data.id
                  : "https://api.whatsapp.com/send?text=Title: " +
                    data.title +
                    "%0aUrl: " +
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/course_detail?courseId=" +
                    data.course.id +
                    "&videoId=" +
                    data.id
              }
            >
              <FontAwesomeIcon className="fa-3x" icon={brands("whatsapp")} />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              className="text-blue ms-2"
              onClick={() => MySwal.close()}
              href={
                data.chapterNumber
                  ? "https://www.facebook.com/dialog/send?app_id=1405438406631984&link=" +
                    encodeURIComponent(
                      window.location.protocol +
                        "//" +
                        window.location.host +
                        "/course_detail?courseId=" +
                        props.courseId +
                        "&chapterId=" +
                        data.id
                    ) +
                    "&redirect_uri=" +
                    encodeURIComponent(
                      window.location.protocol +
                        "//" +
                        window.location.host +
                        "/course_detail?courseId=" +
                        props.courseId +
                        "&chapterId=" +
                        data.id
                    )
                  : "https://www.facebook.com/dialog/send?app_id=1405438406631984&link=" +
                    encodeURIComponent(
                      window.location.protocol +
                        "//" +
                        window.location.host +
                        "/course_detail?courseId=" +
                        data.course.id +
                        "&videoId=" +
                        data.id
                    ) +
                    "&redirect_uri=" +
                    encodeURIComponent(
                      window.location.protocol +
                        "//" +
                        window.location.host +
                        "/course_detail?courseId=" +
                        data.course.id +
                        "&videoId=" +
                        data.id
                    )
              }
            >
              <FontAwesomeIcon className="fa-3x" icon={brands("facebook")} />
            </a>

            <div className="p-2 mt-4 bg-light d-flex justify-content-between align-items-center">
              <input
                type="text"
                size={45}
                readOnly
                className="form-control"
                value={
                  data.chapterNumber
                    ? window.location.protocol +
                      "//" +
                      window.location.host +
                      "/course_detail?courseId=" +
                      props.courseId +
                      "&chapterId=" +
                      data.id
                    : window.location.protocol +
                      "//" +
                      window.location.host +
                      "/course_detail?courseId=" +
                      data.course.id +
                      "&videoId=" +
                      data.id
                }
              />
              <span
                className="cursor-pointer text-red w-50"
                onClick={(e) => {
                  _copy(
                    data.chapterNumber
                      ? window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          props.courseId +
                          "&chapterId=" +
                          data.id
                      : window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          data.course.id +
                          "&videoId=" +
                          data.id
                  );
                }}
              >
                <FontAwesomeIcon icon={regular("copy")} /> COPY
              </span>
            </div>
          </div>
        ),
      });
    }
  };

  const bookmark = async () => {
    if (Object.keys(data).indexOf("topics") > 0) {
      if (!data.topics[0].bookmark) {
        let res = await addCourseBookMark(
          data.topics[0].topicNumber,
          data.topics[0].title,
          props.courseName,
          data.id,
          props.courseId,
          data.topics[0].id
        );
        if (res.status === 200) {
          tagManagerEvents("add_Favourite", props.utm_source);
          setData((prev: any) => ({
            ...prev,
            topics: [
              {
                bookmark: true,
                bookmarkId: res.bookmarkId,
              },
            ],
          }));
        }
      } else {
        const res = await removeCourseBookMark("/" + data.topics[0].id, null);
        if (res.status === 200) {
          setData((prev: any) => ({
            ...prev,
            topics: [
              {
                bookmark: false,
              },
            ],
          }));
        }
      }
    } else {
      if (data.bookmark) {
        const res = await removeCollarBookMark(data.id);
        if (res) {
          setData((prev: any) => ({
            ...prev,
            bookmark: false,
          }));
        }
      } else {
        const res = await addCollarBookMark(data.id, props.courseId);
        if (res) {
          tagManagerEvents("add_favourites", props.utm_source);
          setData((prev: any) => ({
            ...prev,
            bookmark: true,
          }));
        }
      }
    }
  };

  const addCourseBookMark = async (
    topicNumber: string | number,
    title: string,
    courseName?: string,
    chapterId?: string | number,
    courseId?: string | number,
    topicId?: string | number,
    video_id: any = null
  ) => {
    let topic_id = topicId ? "/" + topicId : "";
    let type: "Video" | "Chapter" = video_id ? "Video" : "Chapter";
    
    try {
      const resData = await addCourseBookmarkService({
        msisdn: cookieMsisdn,
        category: type,
        key: topicNumber,
        title: title,
        courseName: courseName || "",
        bookmarkUrl: topic_id,
        chapterId: Number(chapterId) || 0,
        courseId: Number(courseId) || 0,
        videoId: video_id ? Number(video_id) : undefined,
        token: props.token || null
      });
      return { status: 200, bookmarkId: resData.id || resData.bookmarkId }; // Mocking response format to avoid changing callers
    } catch (error) {
      return { status: 400 };
    }
  };

  const removeCourseBookMark = async (
    bookmarkUrl: string | null = null,
    bookmarkId: string | null = null
  ) => {
    try {
      await removeCourseBookmarkService({
        msisdn: cookieMsisdn,
        bookmarkUrl: bookmarkUrl || "",
        id: bookmarkId || "",
        token: props.token || null
      });
      return { status: 200 };
    } catch (error) {
      return { status: 400 };
    }
  };

  const removeCollarBookMark = async (videoId: string | number) => {
    try {
      await removeCollarBookmarkService({
        subscriberId: cookieSubscribeId,
        collarVideoId: Number(videoId),
        token: props.token || null
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  const addCollarBookMark = async (videoId: string | number, courseId?: string | number) => {
    try {
      await addCollarBookmarkService({
        subscriberId: cookieSubscribeId,
        collarVideoId: Number(videoId),
        collarCourseId: Number(courseId) || 0,
        token: props.token || null
      });
      return true;
    } catch (error) {
      return false;
    }
  };

  const NavigateLanding = () => {
    NavigateToLanding();
  };

  const handleChapternoNavigate = () => {
    // if (typeof window != "undefined" && cookieMsisdn) {
      navigate(
        "/course_detail?courseId=" + props.courseId + "&chapterId=" + data.id
      );
    // } else {
    //   NavigateToLanding();
    // }
  };

  const handleVideoNavigate = () => {
    // if (typeof window != "undefined" && cookieMsisdn) {
      navigate(
        "/course_detail?courseId=" + data.course.id + "&videoId=" + data.id
      );
    // } else {
    //   NavigateToLanding();
    // }
  };

  return (
    <div className="card shadow h-100 border-0    br-card">
      <Toast ref={toast} position="bottom-right" />
      <div className="course-card-img position-relative">
        {data.chapterNumber ? (
          <a
            onClick={() => {
              tagManagerEvents("new_videos", props.utm_source);
              handleChapternoNavigate();
            }}
          >
            <div className="overlay justify-content-center align-items-center"></div>
          </a>
        ) : (
          <a
            // href={typeof window != "undefined" && cookieMsisdn ? "#" : undefined}
            onClick={(e) => {
              // if(typeof window != "undefined" && cookieMsisdn) e.preventDefault();
              tagManagerEvents("new_videos", props.utm_source);
              handleVideoNavigate();
            }}
          >
            <div className="overlay justify-content-center align-items-center">
              <FontAwesomeIcon
                icon={solid("circle-play")}
                className="fa fa-3x text-red"
              />
            </div>
          </a>
        )}

        <img
          src={data.thumbnail ? data.thumbnail.replace(
            Config.COURSES_THUMBNAIL,
            Config.COURSES_THUMBNAIL_NEW
          ) : data.thumbnail}
          className="card-img-top "
          alt="img"
        />
      </div>
      <div className="card-body">
        <div className="row my-1">
          <div className="col-9  ">
            <Tooltip
              title={
                data.chapterNumber
                  ? "Chapter " + data.chapterNumber
                  : data.title
              }
              TransitionComponent={Zoom}
              placement="bottom"
            >
              <p className="mb-2 font-12 text-muted text-truncate _title">
                <FontAwesomeIcon icon={solid("book")} className="me-1" />
                {data.chapterNumber
                  ? "Chapter " + data.chapterNumber
                  : data.title}
              </p>
            </Tooltip>
          </div>
          <div className="col-3">
            <span className="">
              {typeof window != "undefined" && cookieMsisdn ? (
                <>
                  <Tooltip title="Share">
                    <FontAwesomeIcon
                      icon={solid("share")}
                      onClick={_share}
                      className="text-red mb-3 _hover cursor-pointer "
                    />
                  </Tooltip>
                  <Tooltip title="Favourite">
                    <FontAwesomeIcon
                      icon={
                        Object.keys(data).indexOf("topics") > 0
                          ? data.topics[0].bookmark
                            ? solid("heart")
                            : regular("heart")
                          : data.bookmark
                          ? solid("heart")
                          : regular("heart")
                      }
                      className="float-end color-red _hover cursor-pointer"
                      onClick={bookmark}
                    />
                  </Tooltip>
                </>
              ) : (
                ""
              )}
            </span>
          </div>
        </div>

        <div className="d-flex flex-column justify-content-between">
          <Tooltip
            title={data.description ? data.description : data.title}
            placement="bottom"
            TransitionComponent={Zoom}
          >
            <p className="fw-bold font-15 text-truncate desc">
              {" "}
              {data.description ? data.description : data.title}
            </p>
          </Tooltip>
          <div>
            {/* {typeof window != "undefined" && cookieMsisdn === null ? (
              <button
                className="btn btn-red _hover px-5 font-12"
                onClick={() => {
                  NavigateLanding();
                }}
              >
                Details
              </button>
            ) : ( */}
              <a
                href={
                  data.chapterNumber
                    ? "/course_detail?courseId=" +
                      props.courseId +
                      "&chapterId=" +
                      data.id
                    : "/course_detail?courseId=" +
                      data.course.id +
                      "&videoId=" +
                      data.id
                }
                className="btn btn-red _hover px-5 font-12"
              >
                Details
              </a>
            {/* )} */}
          </div>
        </div>
      </div>
    </div>
  );
}
